import { ValidationErrors } from '@angular/forms';
import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[issFormFieldError]',
  standalone: true,
})
export class FormFieldErrorDirective {
  public constructor(
    public readonly templateRef: TemplateRef<{
      $implicit: ValidationErrors | null | undefined;
      errorsByFields: Record<string, ValidationErrors>;
    }>,
  ) {}
}
